import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetItemsPayload } from 'Types/getItemsPayload'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { ContractCreateModel, ContractModel } from 'Pages/advertisement/models'

export type ContractState = {
	requestParams: RequestParams
	contract_list: ResponseCatalog<ContractModel>
	contr: ContractCreateModel | null
	openedContr: number
}

export const contractInitialState: ContractState = {
	requestParams: new RequestParams(),
	contract_list: new ResponseCatalog<ContractModel>(),
	contr: null,
	openedContr: null,
}

export namespace contractNS {
	export type getContractsList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setRequestParams = PayloadAction<RequestParams>
	export type setContractsList = PayloadAction<ResponseCatalog<ContractModel>>
	export type GetContracts = PayloadAction<number>
	export type SetContracts = PayloadAction<ContractCreateModel>
	export type CreateContracts = PayloadAction<ContractCreateModel>
	export type SetContrOpened = PayloadAction<number>
	export type ChangeContractFromSocket = PayloadAction<{
		contract_id: number
		status: string
		external_id: string
		registered_at: string
	}>
	export type getContractListSelect = PayloadAction<GetItemsPayload>

	export type UpdateContracts = PayloadAction<{
		id: string
		data: ContractCreateModel
	}>
}

export const contractSlice = createSlice({
	name: 'contract',
	initialState: contractInitialState,
	reducers: {
		getAll: (state, action: contractNS.getContractsList) => {},
		getListSelect: (state, action: contractNS.getContractListSelect) => {},
		setAll: (state, action: contractNS.setContractsList) => {
			state.contract_list = action.payload
		},
		setRequestParams: (state, action: contractNS.setRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.contract_list = new ResponseCatalog<ContractModel>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: contractNS.GetContracts) => {},
		setOne: (state, action: contractNS.SetContracts) => {
			state.contr = action.payload
		},
		createOne: (state, action: contractNS.CreateContracts) => {},
		updateOne: (state, action: contractNS.UpdateContracts) => {},
		setOpened: (state, action: contractNS.SetContrOpened) => {
			state.openedContr = action.payload
		},
		changeContrFromSocket: (state, action: contractNS.ChangeContractFromSocket) => {
			const { contract_id } = action.payload
			const findContrIndex = state.contract_list.entries.findIndex(
				(contr) => contr.id === contract_id
			)
			if (findContrIndex) {
				state.contract_list.entries[findContrIndex] = {
					...state.contract_list.entries[findContrIndex],
					...action.payload,
				}
			}
		},
	},
})
